import { styled } from "@mui/material";
import { BaseTypographyType } from "../../../types/component.type";

export const BaseLegend = styled("legend")<BaseTypographyType>(({ fontweight, fontsize, colour }) => {
    return {
        fontFamily: "Poppins",
        fontWeight: fontweight || "700",
        fontSize: fontsize || "20px",
        lineHeight: "normal",
        color: colour || "var(--dark-color)",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
})
